import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError, of, shareReplay } from "rxjs";
import { NewsResponse, RoadmapResponse, ShowcaseResponse } from "./responses";
import { environment } from "../../environments/environment";

@Injectable()
export class LandingService {
    /** One fetch per session; every logos band on the page shares it. */
    private showcase$: Observable<ShowcaseResponse | null> | null = null;

    constructor(
        private http: HttpClient,
    ) {
    }

    getRoadmap(): Observable<RoadmapResponse> {
        return this.http.get<RoadmapResponse>(`${environment.apiUrl}/landing/roadmap`)
    }

    voteRoadmapItem(featureId: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}/landing/roadmap/${featureId}/vote`, {})
    }

    /**
     * Never from the hydration transfer cache: /changelog is prerendered at build time, so the cached response is the
     * news as of the last landing build, and a release posted since would stay missing until the next one. The
     * browser always asks the API; the prerendered list shows until the fresh one lands.
     */
    getNews(): Observable<NewsResponse> {
        return this.http.get<NewsResponse>(`${environment.apiUrl}/landing/news`, { transferCache: false })
    }

    getShowcase(): Observable<ShowcaseResponse | null> {
        this.showcase$ ??= this.http.get<ShowcaseResponse>(`${environment.apiUrl}/landing/showcase`).pipe(
            catchError(() => of(null)),
            shareReplay(1),
        );
        return this.showcase$;
    }
}

